import { chain } from "wagmi";
import { TraitCategory } from "types";
import fancyBearsAbi from "./abis/fancyBears.abi.json";
import honeyJarsAbi from "./abis/honeyJars.abi.json";
import honeyVestingAbi from "./abis/honeyVesting.abi.json";
import honeyConsumptionAbi from "./abis/honeyConsumption.abi.json";
import honeyAbi from "./abis/honey.abi.json";
import traitsAbi from "./abis/traits.abi.json";
import traitSale from "./abis/traitSale.abi.json";
import traitStaking from "./abis/traitStaking.abi.json";
import multicallAbi from "./abis/multicall.abi.json";
import en from "./locales/en.json";
import { BigNumber } from "ethers";

export { default as theme } from "./theme";

export const environment = process.env.NODE_ENV;

export const apiUrl = process.env.REACT_APP_API_URL;
export const metadataUrl = process.env.REACT_APP_METADATA_URL;
export const filestoreUrl = process.env.REACT_APP_FILESTORE_URL;
export const publicUrl = process.env.PUBLIC_URL;

export const chainName = process.env.REACT_APP_CHAIN_NAME;
export const infuraId = process.env.REACT_APP_INFURA_ID;

export const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

// @ts-expect-error
export const chains = [chain[process.env.REACT_APP_CHAIN_NAME!]];

export const fancyBearsContract = {
  address: process.env.REACT_APP_FANCY_BEARS_ADDRESS!,
  interface: fancyBearsAbi,
};

export const honeyJarsContract = {
  address: process.env.REACT_APP_HONEY_JARS_ADDRESS!,
  interface: honeyJarsAbi,
};

export const honeyTokenContract = {
  address: process.env.REACT_APP_HONEY_TOKEN_ADDRESS!,
  interface: honeyAbi,
};

export const honeyVestingContract = {
  address: process.env.REACT_APP_HONEY_VESTING_ADDRESS!,
  interface: honeyVestingAbi,
};

export const honeyConsumptionContract = {
  address: process.env.REACT_APP_HONEY_CONSUMPTION_ADDRESS!,
  interface: honeyConsumptionAbi,
};

export const traitsContract = {
  address: process.env.REACT_APP_TRAITS_ADDRESS!,
  interface: traitsAbi,
};

export const traitSaleContract = {
  address: process.env.REACT_APP_TRAIT_SALE_ADDRESS!,
  interface: traitSale,
};

export const traitStakingContract = {
  address: process.env.REACT_APP_TRAIT_STAKING_ADDRESS!,
  interface: traitStaking,
};

export const multicallContract = {
  address: process.env.REACT_APP_CHAIN_MULTICALL_ADDRESS!,
  interface: multicallAbi,
};

export const locales = {
  en,
};

export const defaultBearFurColor = 2004;
export const fancyBearsAmount = 7888;
export const honeyJarSize = BigNumber.from("71000000000000000000000");

export const learnMoreUrl = process.env.REACT_APP_LEARN_MORE_URL;
export const honeyUniswapUrl = process.env.REACT_APP_HONEY_UNISWAP_URL;
export const vestingAppUrl = process.env.REACT_APP_VESTING_APP_URL;

export const fancyBearsOpenSeaUrl =
  process.env.REACT_APP_FANCY_BEARS_OPENSEA_URL;

export const openSeaAssetBaseUrl = process.env.REACT_APP_OPENSEA_ASSET_BASE_URL;

export const traitRangesByCategory: {
  [key in TraitCategory]: [from: number, to: number];
} = {
  [TraitCategory.Background]: [1001, 2000],
  [TraitCategory.Fur]: [2001, 3000],
  [TraitCategory.Clothes]: [3001, 4000],
  [TraitCategory.Eyes]: [4001, 5000],
  [TraitCategory.Mouth]: [5001, 6000],
  [TraitCategory.Ears]: [6001, 7000],
  [TraitCategory.Hat]: [7001, 8000],
  [TraitCategory.Special]: [9001, 10000],
};

export const traitCategories: TraitCategory[] = [
  TraitCategory.Background,
  TraitCategory.Fur,
  TraitCategory.Clothes,
  TraitCategory.Eyes,
  TraitCategory.Mouth,
  TraitCategory.Ears,
  TraitCategory.Hat,
  TraitCategory.Special,
];

export const swapableTraitCategories: TraitCategory[] = [
  TraitCategory.Background,
  TraitCategory.Clothes,
  TraitCategory.Eyes,
  TraitCategory.Mouth,
  TraitCategory.Ears,
  TraitCategory.Hat,
  TraitCategory.Special,
];
